import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLightBulb = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_300_6371)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_300_6371",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 25,
			children: /* @__PURE__ */ _jsx("rect", {
				y: .218994,
				width: 24,
				height: 24,
				fill: "currentColor"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_300_6371)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M10.376 18.0266C9.93186 18.0266 9.55394 17.8696 9.24227 17.5554C8.93077 17.2414 8.77502 16.8626 8.77502 16.4189V14.3976C7.86986 13.8208 7.16444 13.0782 6.65877 12.1699C6.15294 11.2616 5.90002 10.2811 5.90002 9.2284C5.90002 7.5309 6.49177 6.08831 7.67527 4.90065C8.85877 3.71281 10.2985 3.1189 11.9945 3.1189C13.6905 3.1189 15.1321 3.71115 16.3193 4.89565C17.5064 6.08031 18.1 7.5214 18.1 9.2189C18.1 10.2749 17.8471 11.2606 17.3413 12.1761C16.8356 13.0918 16.1302 13.8323 15.225 14.3976V16.4189C15.225 16.8626 15.0678 17.2414 14.7533 17.5554C14.4388 17.8696 14.0594 18.0266 13.615 18.0266H10.376ZM10.3828 16.7266H13.6173C13.7071 16.7266 13.7809 16.6978 13.8385 16.6401C13.8962 16.5825 13.925 16.5087 13.925 16.4189V13.6824L14.625 13.2439C15.302 12.8042 15.8338 12.2261 16.2203 11.5096C16.6068 10.7931 16.8 10.0296 16.8 9.2189C16.8 7.8909 16.3314 6.7589 15.3943 5.8229C14.4573 4.8869 13.3239 4.4189 11.9943 4.4189C10.6648 4.4189 9.53336 4.8869 8.60002 5.8229C7.66669 6.7589 7.20002 7.8909 7.20002 9.2189C7.20002 10.0296 7.39327 10.7931 7.77977 11.5096C8.16627 12.2261 8.69802 12.8042 9.37502 13.2439L10.075 13.6824V16.4189C10.075 16.5087 10.1039 16.5825 10.1615 16.6401C10.2192 16.6978 10.2929 16.7266 10.3828 16.7266ZM10.2865 21.3189C10.017 21.3189 9.79136 21.2279 9.60952 21.0459C9.42752 20.8641 9.33652 20.6384 9.33652 20.3689V20.0189H14.6635V20.3689C14.6635 20.6384 14.5725 20.8641 14.3905 21.0459C14.2087 21.2279 13.983 21.3189 13.7135 21.3189H10.2865Z",
				fill: "currentColor"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_300_6371",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor",
			transform: "translate(0 0.218994)"
		})
	}) })]
});
export default SvgLightBulb;
